import { useState, useEffect } from 'react';
import { supabase } from './supabase';
import AuthScreen from './AuthScreen';
import GearVault from './GearVault';

// Cache key for last-known session user (so we can skip the blank loading flash)
const SESSION_CACHE_KEY = 'gearvault-session-user';

export default function App() {
  // Seed from localStorage so we never show a blank white screen on reload
  const [session, setSession] = useState(() => {
    try {
      const cached = localStorage.getItem(SESSION_CACHE_KEY);
      return cached ? { user: JSON.parse(cached), _cached: true } : undefined;
    } catch {
      return undefined;
    }
  });

  useEffect(() => {
    // Real session check — replaces the cached stub
    supabase.auth.getSession().then(({ data: { session: s } }) => {
      if (s) {
        localStorage.setItem(SESSION_CACHE_KEY, JSON.stringify(s.user));
        setSession(s);
      } else {
        localStorage.removeItem(SESSION_CACHE_KEY);
        setSession(null);
      }
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, s) => {
      if (s) {
        localStorage.setItem(SESSION_CACHE_KEY, JSON.stringify(s.user));
        setSession(s);
      } else {
        localStorage.removeItem(SESSION_CACHE_KEY);
        setSession(null);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  async function handleSignOut() {
    localStorage.removeItem(SESSION_CACHE_KEY);
    await supabase.auth.signOut();
  }

  // Only show the hard loader when we have NO cache hint at all
  if (session === undefined) {
    return (
      <div style={{ minHeight:'100vh', background:'#111112', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Share Tech Mono','Courier New',monospace", color:'#7a7872', fontSize:'.8rem', letterSpacing:'.15em' }}>
        <div style={{ textAlign:'center' }}>
          <svg width="36" height="36" viewBox="0 0 36 36" style={{ marginBottom:'1rem', opacity:.4 }}>
            <polygon points="18,2 26,8 34,8 34,28 26,28 18,34 10,28 2,28 2,8 10,8" fill="none" stroke="#0eb8a0" strokeWidth="1.5"/>
            <text x="18" y="23" textAnchor="middle" fontSize="14" fill="#0eb8a0" fontFamily="serif">V</text>
          </svg>
          <div>LOADING…</div>
        </div>
      </div>
    );
  }

  if (!session) return <AuthScreen />;

  return <GearVault user={session.user} onSignOut={handleSignOut} />;
}
